module.exports = __webpack_public_path__ + "static/ems-7f802144100c1ad93578439380542626.jpg";